export default "__VITE_ASSET__DXZLfq_w__"